/**
 * Card Surface Styles — Frosted / Clear / Solid
 * 
 * Replicates YulOnTap's cardSurface.js architecture.
 * Used by guest-facing survey/alert pages to apply the
 * correct visual treatment to the content card.
 */

export const CARD_STYLES = {
  frosted: {
    id: 'frosted',
    label: 'Frosted',
    description: 'Translucent + blur',
    classes: 'bg-white/5 backdrop-blur-md border border-white/10',
    textColor: 'text-white',
    subTextColor: 'text-white/70',
  },
  clear: {
    id: 'clear',
    label: 'Clear',
    description: 'Wallpaper shows through',
    classes: 'bg-white/0 border border-white/15',
    textColor: 'text-white',
    subTextColor: 'text-white/70',
  },
  solid: {
    id: 'solid',
    label: 'Solid',
    description: 'Fully opaque card',
    classes: 'bg-slate-900 border border-slate-800',
    textColor: 'text-white',
    subTextColor: 'text-slate-400',
  },
};

export const DEFAULT_CARD_STYLE = 'frosted';

/**
 * Get the resolved card style. Falls through:
 *   card-specific → org/hotel default → 'frosted'
 */
export function getCardSurface(cardStyle, orgDefault) {
  const style = cardStyle || orgDefault || DEFAULT_CARD_STYLE;
  return CARD_STYLES[style] || CARD_STYLES[DEFAULT_CARD_STYLE];
}

/**
 * Should we use the wallpaper/frosted theme (dark text) or default theme (light bg)?
 */
export function hasWallpaper(branding) {
  return !!(branding?.wallpaper_url);
}
